import styles from "./index.module.scss";

export default function Comment({ comment }) {
  return (
    <div className={styles.Item}>
      <div>
        <div className={styles.Name}>Ответ администратора</div>
        <div className={styles.Text}>
          <div dangerouslySetInnerHTML={{ __html: comment }} />
        </div>
      </div>
    </div>
  );
}
